import analytics from '@repo/analytics';
import { getShareLink, ShareType } from '@repo/editor/src/utils/share';
import { withEventScope } from '@repo/event-processor';
import FacebookCircleIcon from '@repo/ui/components/Icon/FacebookCircleIcon';
import LinkedinIcon from '@repo/ui/components/Icon/LinkedinIcon';
import LinkShareIcon from '@repo/ui/components/Icon/LinkShareIcon';
import PinterestIcon from '@repo/ui/components/Icon/PinterestIcon';
import TwitterIcon from '@repo/ui/components/Icon/TwitterIcon';
import { fireToast } from '@repo/ui/components/Toast';

import ShareIconSwitcher from 'components/ShareIcon/ShareIconSwitcher';
import { POST_SHARE } from 'global/analyticsEvents';
import { buildPostShareUrl } from 'global/urlUtils';
import { FlexRow } from 'styles/layouts';

import { ShareProps } from './types';

const Share = ({ post }: ShareProps) => {
  const handleShare = async (key: ShareType) => {
    if (typeof window === 'undefined') {
      return;
    }

    const postURL = buildPostShareUrl(post);
    const url = getShareLink(key, postURL, {
      preview: post.template.templatePreviewObjectName,
      title: post.template.name,
    });
    if (!url) {
      return;
    }

    analytics.track(POST_SHARE, { label: key.toLowerCase(), id: post.id });

    const isLinkShare = key === 'Link';
    if (isLinkShare) {
      await navigator.clipboard.writeText(url);
      fireToast({ label: 'Link copied to clipboard' });
    } else {
      window.open(url, '_blank');
    }
  };

  return (
    <FlexRow gap="10px">
      <ShareIconSwitcher
        icon={FacebookCircleIcon}
        onClick={() => handleShare(ShareType.Facebook)}
      />
      <ShareIconSwitcher
        icon={TwitterIcon}
        onClick={() => handleShare(ShareType.Twitter)}
      />
      <ShareIconSwitcher
        icon={PinterestIcon}
        onClick={() => handleShare(ShareType.Pinterest)}
      />
      <ShareIconSwitcher
        icon={LinkedinIcon}
        onClick={() => handleShare(ShareType.LinkedIn)}
      />
      <ShareIconSwitcher
        icon={LinkShareIcon}
        onClick={() => handleShare(ShareType.Link)}
      />
    </FlexRow>
  );
};

export default withEventScope(Share, { module: 'postShare' });
